import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import AcademicServices from "./sections/AcademicServices";
import BehavioralSupport from "./sections/BehavioralSupport";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <AcademicServices />
      <BehavioralSupport />
      <Footer />
    </div>;
}